import React, { useContext, useEffect } from "react";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardDiv from "modules/common/card-div/CardDiv";
import { ProgressBar } from "react-bootstrap";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { FeedbackDate } from "./FeedbackTab";
import { useDeliveryFeedback } from "./store";
import xlsx from "json-as-xlsx";
import moment from "moment";

function DeliveryPlan({ data, planLength }) {
  const { deliveryExperiment, onDeliveryCount } = data;

  const { startDate, endDate } = useContext(FeedbackDate);
  const {
    deliveryDownloadData,
    delivDownLoading,
    fetchDeliveryFeedbackDownload,
  } = useDeliveryFeedback();

  useEffect(() => {
    fetchDeliveryFeedbackDownload(startDate.valueOf(), endDate.valueOf());
  }, [startDate]);

  const ExcelDownload = (excelData) => {
    const _data = excelData?.map((el) => {
      return {
        ...el,
        userName: el.user ? el.user?.first_name : "",
        userPhoneNumber: el.user ? el.user?.phone_number : "",
        userGender: el.user ? el.user?.gender : "",
        userEmail: el.user ? el.user?.email : "",
        orderId: el.user ? el?.order_id : "",
        onTimeDelivery: el.on_time_delivery ? el?.on_time_delivery : "",
        notificationReceived: el.notification_recieved
          ? el.notification_recieved
          : "",
        deliveryExperience: el.delivery_experience
          ? el.delivery_experience
          : "",
        additionalComment: el.additional_comments ? el.additional_comments : "",
        updatedAt: moment(el.updatedAt).format("DD-MM-YYYY HH:mm:ss"),
        createdAt: moment(el.createdAt).format("DD-MM-YYYY HH:mm:ss"),
      };
    });
    const data = [
      {
        sheet: "DeliveryFeedbacks",
        columns: [
          { label: "Case Id", value: "case_id" },
          { label: "Customer Name", value: "userName" },
          { label: "Customer Phone Number", value: "userPhoneNumber" },
          { label: "Customer Email Id", value: "userEmail" },
          { label: "Customer Gender", value: "userGender" },
          { label: "Order Id", value: "orderId" },
          { label: "On Time Delivery", value: "onTimeDelivery" },
          { label: "Notification Received", value: "notificationReceived" },
          { label: "Delivery Experience", value: "deliveryExperience" },
          { label: "Additional Comment", value: "additional Comment" },
          {
            label: "Created At",
            value: "createdAt",
          },
          {
            label: "Updated At",
            value: "updatedAt",
          },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: `Delivery Feedbacks`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row gap-4">
            <div className="">Rating of Customer Happy With Traya</div>
            <div className="d-flex gap-2">
              <div className="fw-bold">Total Count:</div>
              <div className="fw-bold">{planLength || "0"}</div>
            </div>
          </div>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={() => ExcelDownload(deliveryDownloadData?.feedbacks)}
            disabled={isEmpty(deliveryDownloadData?.feedbacks)}
          >
            Download
          </Button>
        </div>
      }
      component={
        <div className="d-flex gap-2">
          <div className="mt-n2 w-75">
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={5}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={
                    (+deliveryExperiment?.delivery_experience_5 / planLength) *
                    100
                  }
                />
              </div>
              <div className="fw-bold">
                {deliveryExperiment?.delivery_experience_5}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={4}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={
                    (+deliveryExperiment?.delivery_experience_4 / planLength) *
                    100
                  }
                />
              </div>
              <div className="fw-bold">
                {deliveryExperiment?.delivery_experience_4}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={3}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={
                    (+deliveryExperiment?.delivery_experience_3 / planLength) *
                    100
                  }
                />
              </div>
              <div className="fw-bold">
                {deliveryExperiment?.delivery_experience_3}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={2}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={
                    (+deliveryExperiment?.delivery_experience_2 / planLength) *
                    100
                  }
                />
              </div>
              <div className="fw-bold">
                {deliveryExperiment?.delivery_experience_2}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={1}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={
                    (+deliveryExperiment?.delivery_experience_1 / planLength) *
                    100
                  }
                />
              </div>
              <div className="fw-bold">
                {deliveryExperiment?.delivery_experience_1}
              </div>
            </div>{" "}
          </div>
          <div className="w-25">
            <div className="d-flex flex-row align-items-center gap-2">
              <div className="fs-1">On Time Delivery:</div>
              <div className="w-50 ms-2">
                <ProgressBar
                  animated={true}
                  now={
                    (+onDeliveryCount?.on_time_delivery_yes / planLength) * 100
                  }
                />
              </div>
              <div className="fs-1 fw-bold">
                {onDeliveryCount?.on_time_delivery_yes}
              </div>
            </div>
            <div className="d-flex flex-row gap-2 align-items-center">
              <div className="fs-1 ms-2">Delayed Delivery:</div>
              <div className="w-50 ms-1">
                <ProgressBar
                  animated={true}
                  variant="danger"
                  now={
                    (+onDeliveryCount?.on_time_delivery_no / planLength) * 100
                  }
                />
              </div>
              <div className="fs-1 fw-bold">
                {onDeliveryCount?.on_time_delivery_no}
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default DeliveryPlan;
